import { Check, X } from "lucide-react";

import RuvixxDate from "components/RuvixxDate";
import { NoteTemplateTableActions } from "./NoteTemplateTableActions";

export const getNoteTemplateTableColumns = () => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 60,
      cell: ({ row }) => <p className="tw:font-bold">{row.original?.id}</p>,
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "name",
    },
    {
      header: "Enabled",
      id: "Enabled",
      accessorKey: "enabled",
      size: 80,
      cell: ({ row }) =>
        row.original.enabled ? (
          <Check className="tw:size-4 tw:text-success" aria-label="Enabled" />
        ) : (
          <X className="tw:size-4 tw:text-destructive" aria-label="Disabled" />
        ),
    },
    {
      header: "Created At",
      id: "Created At",
      accessorKey: "created_at",
      cell: ({ row }) => <RuvixxDate date={row.original.created_at} />,
    },
    {
      header: "Updated At",
      id: "Updated At",
      accessorKey: "updated_at",
      cell: ({ row }) => <RuvixxDate date={row.original.updated_at} />,
    },
    {
      header: "Created By",
      id: "Created By",
      accessorKey: "creator_user_full_name",
    },
    {
      header: <div></div>,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => <NoteTemplateTableActions original={row.original} />,
    },
  ];
};
